import { render, staticRenderFns } from "./RoomsTable.vue?vue&type=template&id=34a87472&scoped=true&"
import script from "./RoomsTable.vue?vue&type=script&lang=js&"
export * from "./RoomsTable.vue?vue&type=script&lang=js&"
import style0 from "./RoomsTable.vue?vue&type=style&index=0&id=34a87472&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a87472",
  null
  
)

export default component.exports